import {
  SecondhandTaxesLandingPageSection,
  NO_CHANGES_TO_TAXES_IMAGE_BASE_URL,
} from '../../constants'

const getExampleItemsContent = (countryCode = 'UK', itemNumbers = 3) => {
  const avatarImageUrl = `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-Avatar`

  const getExampleItemData = (order: number) => ({
    subHeader: `secondhand_taxes.examples.item${order}.sub_title`,
    header: `secondhand_taxes.examples.item${order}.title`,
    description: `secondhand_taxes.examples.item${order}.description`,
    exampleUser: `secondhand_taxes.examples.item${order}.user`,
    exampleUserDescription: `secondhand_taxes.examples.item${order}.user_description`,
    exampleUserImage: {
      src: `${avatarImageUrl}-${order}-114x114.png`,
      srcSet: `${avatarImageUrl}-${order}-80x80.png 330w, ${avatarImageUrl}-${order}-114x114.png 520w, ${avatarImageUrl}-${order}-114x114@2x.png 1040w, ${avatarImageUrl}-${order}-114x114@3x.png 1560w,`,
    },
    exampleUserFinancialRecords: [
      {
        key: `secondhand_taxes.examples.item${order}.financial_records.income_key`,
        value: `secondhand_taxes.examples.item${order}.financial_records.income_value`,
      },
      {
        key: `secondhand_taxes.examples.item${order}.financial_records.profit_key`,
        value: `secondhand_taxes.examples.item${order}.financial_records.profit_value`,
      },
      {
        key: `secondhand_taxes.examples.item${order}.financial_records.taxes_key`,
        value: `secondhand_taxes.examples.item${order}.financial_records.taxes_value`,
      },
    ],
  })

  return Array.from({ length: itemNumbers }, (_, index) => index + 1).map(contentItemOrder =>
    getExampleItemData(contentItemOrder),
  )
}

export const getExamplesSectionContent = (countryCode = 'UK', itemNumbers = 3) => ({
  componentId: SecondhandTaxesLandingPageSection.Examples,
  testId: 'no-changes-to-taxes--examples-section',
  text: {
    title: 'secondhand_taxes.examples.title',
  },
  cards: getExampleItemsContent(countryCode, itemNumbers),
})
